import React from 'react';
import { 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  SelectChangeEvent 
} from '@mui/material';

// Mock data for agent tasks
const AGENT_TASKS = [
  { 
    value: 'revenue_analysis', 
    label: 'Show top 10 users by revenue',
    description: 'Analyze user revenue data and generate insights'
  },
  { 
    value: 'feedback_summary', 
    label: 'Summarize recent feedback',
    description: 'Aggregate and analyze customer feedback'
  },
  { 
    value: 'onboarding_analysis', 
    label: 'Rank onboarding flows by completion',
    description: 'Evaluate onboarding process effectiveness'
  },
  { 
    value: 'churn_prediction', 
    label: 'Predict potential churn',
    description: 'Identify at-risk customers'
  },
  { 
    value: 'feature_usage', 
    label: 'Analyze feature adoption',
    description: 'Track and analyze feature usage patterns'
  }
];

interface AgentTaskSelectorProps {
  selectedTask: string;
  onTaskChange: (task: string) => void;
}

const AgentTaskSelector: React.FC<AgentTaskSelectorProps> = ({ 
  selectedTask, 
  onTaskChange 
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onTaskChange(event.target.value);
  };

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <FormControl fullWidth>
        <InputLabel id="agent-task-select-label">Select Agent Task</InputLabel>
        <Select
          labelId="agent-task-select-label"
          id="agent-task-select"
          value={selectedTask}
          label="Select Agent Task"
          onChange={handleChange}
          sx={{ 
            backgroundColor: '#1E293B',
            color: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.2)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.5)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3B82F6',
            },
          }}
        >
          {AGENT_TASKS.map((task) => (
            <MenuItem key={task.value} value={task.value}>
              {task.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default AgentTaskSelector; 